import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * 業種一覧
 *
 * 業種データの一覧を返す
 */
export class FetchIndustry implements APIRequest<Monitaro.FetchIndustryResponse> {
  response: Monitaro.FetchIndustryResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/industries`
  }
}

/**
 * 業種データの取得
 *
 * 指定されたIDの業種情報を返す
 */
export class GetIndustry implements APIRequest<Monitaro.GetIndustryResponse> {
  response: Monitaro.GetIndustryResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(industry: string) {
    this.path = `/industries/${industry}`
  }
}
